module.exports = __webpack_public_path__ + "r-v3/img/video-off.63d872b4.svg";